import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { getAllGolfersStats } from '@/api/golfer/golfer.actions.ts';
import { GolferStatsData } from '@/api/golfer/golfer.types.ts';
import { isApiSuccess } from '@/api/shared.types.ts';
import { useAsync } from '@/hooks/global/useAsync.ts';

const DEFAULT_PAGE_SIZE = 10;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useGolfersStats = (pageSize = DEFAULT_PAGE_SIZE) => {
  const [golfersStats, setGolfersStats] = useState<GolferStatsData[]>([]);
  const [golfersCount, setGolfersCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const { run: runFetchAll, isLoading: isFetchingAll } = useAsync();

  const fetchGolfersStats = async (page = 1): Promise<void> => {
    const response = await runFetchAll(() =>
      getAllGolfersStats(page, pageSize)
    );

    if (isApiSuccess(response)) {
      setGolfersStats(response.content.data);
      setGolfersCount(response.content.pagination.total);
      return;
    }

    toast.error(response.error.message);
    setGolfersStats([]);
  };

  useEffect(() => {
    fetchGolfersStats(currentPage);
  }, [currentPage]);

  return {
    golfersStats,
    golfersCount,
    isFetchingAll,
    refetch: fetchGolfersStats,
    pageSize,
    currentPage,
    setCurrentPage,
  };
};
